import { Outlet } from 'react-router-dom'
import { isCrmCoreRole, type Role } from '@crm/shared'
import { useAuthStore } from '../../modules/auth/authStore'
import { EmptyState } from '../ui/EmptyState'

/**
 * Ворота бизнес-разделов (заявки, клиенты, КП, закупка, заказы, справочники…):
 * пускают только роли CRM_CORE_ROLES — все роли до этапа 3. Роли этапа 3
 * (бухгалтер, логист, склад) видят заглушку и не шлют запросов к API, пока им не
 * откроют раздел явно (23.09.2026, docs/stage-3-plan.md, C1). ProtectedRoute роль
 * не проверяет, поэтому без этих ворот страница открывалась по прямой ссылке.
 *
 * `extraRoles` — роли этапа 3, которым открыты разделы за этими воротами
 * (с куска C2 бухгалтеру — «Курс валют» и «Планирование»).
 */
export function CrmRoleGate({ extraRoles = [] }: { extraRoles?: readonly Role[] }) {
  const role = useAuthStore((s) => s.user?.role)
  if (!role || !(isCrmCoreRole(role) || (extraRoles as readonly string[]).includes(role))) {
    return (
      <div className="p-6">
        <EmptyState
          title="Раздел недоступен"
          description="Для вашей роли этот раздел пока не открыт."
        />
      </div>
    )
  }
  return <Outlet />
}
